import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type InterviewDeletionFailedAction = {
	type: 'INTERVIEW_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): InterviewDeletionFailedAction => ({
	type: 'INTERVIEW_DELETION_FAILED',
	payload,
});
